import services from './../../services/service'; // Service Class
import Preset from './../../mixins/preset.js'; //preset
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import HorizontalWidget from '../HorizontalWidget.vue'; // HorizontalWidget
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; // Search Bar
//
import DataServer from '../../mixins/dataserver.js'; //DataSharableServing Class
import CNdiscountForm from './../../templates/CNdiscountForm/index.vue' //payent modal
// import RegService from '../../templates/RegisterService/index.vue'; //call the register class

let service = new services();

export default {
    name: 'CNdiscounts',
    mixins: [Preset,DataServer],
    data () {
        return {
            can_set_discount: false,
            set_new_business:false,
            // user: {},
            cndiscounts:{},
            cndiscount:{},
            cndiscount_payment_data:{},
            preview_form: false,
            view_info:false,
            // businesses: {},
            // business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            disable_btn: false,
            process_loading: false,
        }
    },
    components: {
        'second-header': SecondHeader,
        'horizontal-widget': HorizontalWidget,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar,
        'cndiscount-form':CNdiscountForm
       // 'cnpayment-modal': CNpaymentModal,
        // 'set-reg': RegService,
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
            }
        }
    },
    methods: {
        toggleComponent(id){
            var stl = document.getElementById(id).style.display;
            if(stl == "block"){
                document.getElementById(id).style = "display:none";
            }else{
                document.getElementById(id).style = "display:block";
            }
        },

        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },

        setReload(){
            location.reload();
        },

        setPreps(){
            //check business status
            this.set_payment_object_title = "Make CNdiscount Payment"; //extended params //may be faster than parents //check effect if redone
        },

        setReg(){
            localStorage.setItem("current_page",'cndiscountsetup');
            location.replace('register');
        },

        setAddNewBusiness(){
            this.business = {};
            this.set_new_business = true;
        },
       
        
    },
    mounted: function(){
        //
        this.setPreps();
    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        
        //this.getSearchBusiness();
        // this.getAllBusinesses();
        // this.getAllBusinesses(0,this.pag_intv);
        // this.getCNdiscounts(0,this.pag_intv);
     }
}


// WEBPACK FOOTER //
// ./src/components/CNdiscountSetup/script.js